import script from "./PipingScreenShare.vue?vue&type=script&setup=true&lang=ts"
export * from "./PipingScreenShare.vue?vue&type=script&setup=true&lang=ts"

import "./PipingScreenShare.vue?vue&type=style&index=0&id=182cd4ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-182cd4ae"]])

export default __exports__